export default __webpack_public_path__ + "static/media/logoCondomob_novo2021.204c4f55.svg";